module.exports = __webpack_public_path__ + "static/media/3.d7e0fb18.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/肉桂捲/3.JPG
// module id = 926
// module chunks = 0